import { Injectable } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FuseMatchMediaService {

  onMediaChange = new BehaviorSubject<string>('');

  constructor(private readonly mediaObserver: MediaObserver) {
    this.init();
  }

  private init(): void {
    this.mediaObserver
      .asObservable()
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        map(changes => changes[0]),
        filter(change => this.onMediaChange.value !== change.mqAlias)
      )
      .subscribe((change) => {
        this.onMediaChange.next(change.mqAlias);
      });
  }
}
